<div class="main-div" >
    <div class="mainDiv2">
        <div class="heading-div" fxLayout="row wrap" fxLayoutAlign="center">
            <p>PRICING AND PLANS</p>
        </div>
 
        <div class="priceCard-div" fxLayout="row wrap" fxLayout.lt-sm="column">
 
            <div class="priceCard"  fxFlex.gt-xs="27%" fxFlex.lt-sm="100%" *ngFor="let item of cardArray; let i = index">
                <div class="circular-div" [ngClass]="i % 2 === 0 ? 'blueColor' : 'orangeColorHeading'">${{item.amount}}</div>
                <div class="cardHeader" [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'">
                    <p class="top-heading">{{item.title}}</p>
                </div>
                <div class="cardBody">
                    <ul class="bulletText" [ngClass]="i % 2 === 0 ? 'blueColor blueVector' : 'orangeColorText orangeVector'">
                        <li *ngFor="let list of item.description">
                            <span>{{list}}</span>
                        </li>
                    </ul>
                    <div class="buttonDiv">
                        <!-- Creating buttons on based on condition -->
                        <!-- When user is not signed -->
                        <button *ngIf="!isUserLogin"
                                class="buttons buttonGradient"
                                [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'"
                                (click)="handleButton(item)" >
                            JOIN NOW
                        </button>
                        <!-- When user is signed and Amount is zero-->
                        <button *ngIf="isUserLogin && item.amount === 0"
                                class="buttons buttonGradient"
                                [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'"
                                (click)="handleButton(item)" >
                            {{ item.buttonName }}
                        </button>
                        <!-- When user is signed and Amount is greater than 0 and is not a founder -->
                        <button *ngIf="isUserLogin && item.amount > 0 && (!isFounder || !(item.title === 'Founding Patron')) && !item.paymentDone"
                                class="buttons buttonGradient"
                                [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'"
                                (click)="handleButton(item)" >
                            {{ item.buttonName }}
                        </button>
                        <!-- When user is founder and amount is greater than zero -->
                        <button *ngIf="isUserLogin && item.amount > 0 && isFounder && item.title === 'Founding Patron'"
                                class="buttons buttonGradient"
                                [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'"
                                data-bs-toggle= 'modal'
                                data-bs-target="#hotlineModal">
                            HOTLINE
                        </button>
                        <button *ngIf="item.paymentDone && item.title !== 'Founding Patron'"
                            class="buttons buttonGradient"
                            [ngClass]="i % 2 === 0 ? 'blueGradient' : 'orangeGradient'"
                            style="cursor: unset;">
                            Coming soon ({{item.title}})
                        </button>
                        
                        <!-- Modal -->
                        <div class="modal fade" id="hotlineModal" tabindex="-1" aria-labelledby="hotlineModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" style="background-color: white;">
                            <div class="modal-content" >
                                <div class="modal-header" style="background-color: white; color: #000;">
                                <h2 class="modal-title" id="hotlineModalLabel">Patron Hotline</h2>
                                </div>
                                <div class="modal-body" style="background-color: white;">
                                <textarea name="patronHoline" id="patronHoline" class="textareaStyle" cols="30" rows="10" placeholder="Please edit this text to send your ideas and thoughts to us! As a Founding Patron of Creatics, the Founders and Team at Creatics would love to hear from you about any suggestions of how we can enhance or improve Creatics services and offerings. After all 'Together We Create' is more than our motto -- we are looking to create the best Creatics for you and the wonderful fans and creators of film, books, VR, AR, fashion, art, technology, dance, music, science, and more." [(ngModel)]="hotlineMsg" style="width: 100%;"></textarea>
                                </div>
                                <div class="modal-footer" style="background-color: white;">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetHotlineMsg()">Close</button>
                                <button type="button" class="btn btn-primary" (click)="handleHotlineSubmit()" data-bs-dismiss="modal">Save changes</button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</div>